/**
 * Cart Dropdown — fast, cached, minimal
 */
(function($) {
  'use strict';

  var $btn, $dropdown, $items, $badge, $foot, $total, $close;
  var cache = null;
  var cacheKey = 'cs_cart_cache';
  var cacheTimeout = 60000; // 1 minute

  function init() {
    $btn      = $('#cart-button');
    $dropdown = $('#cart-dropdown');
    $items    = $('#cart-dropdown-items');
    $badge    = $('#cart-badge');
    $foot     = $('#cart-dropdown-foot');
    $total    = $('#cart-dropdown-total');
    $close    = $('#cart-dropdown-close');

    if (!$btn.length) return;

    // Restore badge from cache instantly (no AJAX on load).
    restoreFromCache();

    $btn.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if ($dropdown.hasClass('is-visible')) {
        close();
      } else {
        open();
      }
    });

    $close.on('click', close);
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.c-cart__container').length) close();
    });

    // WC events — refresh cache.
    $(document.body).on('added_to_cart removed_from_cart updated_cart_totals', function() {
      fetchCart(true);
    });

    // URL param: open=1
    if (getParam('open') === '1') {
      setTimeout(function() { fetchCart(true); open(); }, 800);
    }
  }

  function open() {
    fetchCart(false);
    $dropdown.addClass('is-visible');
  }

  function close() {
    $dropdown.removeClass('is-visible');
  }

  function restoreFromCache() {
    try {
      var raw = localStorage.getItem(cacheKey);
      if (raw) {
        var data = JSON.parse(raw);
        if (data && Date.now() - data.ts < cacheTimeout) {
          render(data.cart);
          return;
        }
      }
    } catch(e) {}
    // No valid cache — fetch once quietly for badge.
    fetchCart(false);
  }

  function fetchCart(force) {
    if (!force && cache) {
      render(cache);
      return;
    }

    $.post(window.location.origin + '/wp-admin/admin-ajax.php', {
      action: 'get_cart_contents_custom'
    }, function(data) {
      cache = data;
      try {
        localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), cart: data }));
      } catch(e) {}
      render(data);
    });
  }

  function render(data) {
    if (!$items) return;
    $items.empty();

    var count = 0;
    if (data && data.items && data.items.length) {
      data.items.forEach(function(item) {
        count += parseInt(item.quantity) || 0;
        // Shorten name: strip " | Event Name" suffix for display.
        var name = item.name;
        var pipe = name.lastIndexOf(' | ');
        if (pipe > 0) name = name.substring(0, pipe);

        $items.append(
          '<div class="c-cart__dropdown-item">' +
            '<div class="c-cart__dropdown-item-info">' +
              '<p class="c-cart__dropdown-item-name">' + esc(name) + '</p>' +
              '<p class="c-cart__dropdown-item-meta">Qty: ' + item.quantity + '</p>' +
            '</div>' +
            '<span class="c-cart__dropdown-item-price">' + item.subtotal + '</span>' +
          '</div>'
        );
      });
      $total.html(data.cart_total || '');
      $foot.show();
    } else {
      $items.html('<p class="c-cart__dropdown-empty">Your cart is empty</p>');
      $foot.hide();
    }

    updateBadge(count);
  }

  function updateBadge(count) {
    if (count > 0) {
      $badge.text(count).addClass('has-items');
      if (parseInt($badge.data('prev') || 0) !== count) {
        $badge.addClass('pulse');
        setTimeout(function() { $badge.removeClass('pulse'); }, 300);
      }
      $badge.data('prev', count);
    } else {
      $badge.text('').removeClass('has-items');
    }
  }

  function getParam(name) {
    var r = new RegExp('[?&]' + name + '=([^&#]*)');
    var m = r.exec(location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  $(init);
})(jQuery);
